export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f66049b169eeb7eb1c09ab12bf766c8e0ca5f7d94&name=fetchTypeahead!'